




































import { Vue, Component, Prop } from 'vue-property-decorator'
import { UrlType } from '@/constants/urlType'
import { getModule } from 'vuex-module-decorators'
import TitleModule from '@/store/titleModule'
import apiService from '@/services/apiService'
import UserModel from '../models/user/userModel'

const titleModule = getModule(TitleModule)

@Component({
  components: {}
})
export default class CompanyAdmin extends Vue {
  // Extension Id
  @Prop(String) readonly id!: string

  private user: UserModel = new UserModel()

  private loading: boolean = false

  private async created() {
    await this.getUser()
  }

  private async getUser(): Promise<void> {
    this.user = await apiService.get<UserModel>(UrlType.User, this.id)
    titleModule.setPageTitle(
      'User Details: ' + this.user.firstname + ' ' + this.user.lastname
    )
  }

  private async saveUser(): Promise<void> {
    await apiService.put<UserModel>(UrlType.User, this.id, this.user)
  }
}
